<template>
  <div class="card">
     <div class="top">
         <el-input v-model="form.name" placeholder="输入姓名搜寻"  suffix-icon="el-icon-search" @keyup.enter.native="getAdmin"></el-input>
         <el-button @click="addUser" v-if="$isPermission('agencyAdmin.create')">新增使用者</el-button>
     </div>
    <el-table
      :data="tableData"
      style="width: 100%;margin-top: 20px"
      :header-cell-style="{'background':'#C6C6C6','color':'#ffffff'}">
      <el-table-column
        prop="id"
        label="编号"
        >
      </el-table-column>
      <el-table-column
        prop="name"
        label="姓名"
        >
      </el-table-column>
      <el-table-column
        prop="job"
        label="職稱">
      </el-table-column>
      <el-table-column
        prop="account"
        label="帳號">
      </el-table-column>
      <el-table-column
        prop="created_at"
        label="啟用日">
      </el-table-column>
      <el-table-column
        prop="roles"
        label="權限等級">
        <template slot-scope="{row}">
           <span v-for="(item,i) in row.roles" :key="i">
               {{item.name+(i== row.roles.length-1?'':'、')}}
           </span>
        </template>
      </el-table-column>
      <el-table-column
        label="更多操作"
        width="100">
        <template v-slot="{row}">
          <el-button v-if="$isPermission('agencyAdmin.update')" class="checkbtn" @click="handleCheck(row)" type="text" size="small">查看 / 编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="margin-top: 20px"
      background
      layout="prev, pager, next"
      @current-change="handleCurrentChange"
      :total="total">
    </el-pagination>
<userDaig ref="userDaig" :roleList="roleList" @done="getagencyAdmin"></userDaig>
  </div>
</template>


<script>
import { agencyAdmin, roleAll } from "@/api";

export default {
  name: "user.vue",
  components: {
    userDaig: () => import('@/views/System/userDig.vue')
  },
  data(){
    return{
      tableData: [],
      form:{
        page:1,
        limit:10,
        name: ''
      },
      total: 0,
      roleList:[]
    }
  },
  mounted() {
    this.getroleAll()
    this.getagencyAdmin()
  },
  methods:{
    getroleAll(){
      roleAll().then(res =>{
         this.roleList = res.data.list
      })
    },

    getAdmin(){
      this.form.page = 1
      this.getagencyAdmin()
    },

    getagencyAdmin(){
      agencyAdmin(this.form).then(res =>{
           this.tableData = res.data.list
           this.total = res.data.total
      })
    },

    handleCheck(row){
      this.$refs.userDaig.init(row)
    },
    handleCurrentChange(val) {
      this.form.page = val
      this.getagencyAdmin()
    },
    addUser(){
      this.$refs.userDaig.init()
    }
  }
};
</script>



<style scoped lang="scss">
  .card{
    padding: 30px;
    border-radius: 15px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    background: #FFFFFF;
    margin-top: 20px;
    .top{
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      gap: 10px;
      .el-input{
        width: 400px;
      }
      ::v-deep .el-input__inner{
        border: none;
        background: #F8F8F8;
      }
      .el-button{
        color: #FFFFFF;
        border: none;
        background: #DBBD80;
      }
    }
  }
  .el-button--text {
    color: #DBBD80;
    padding: 5px 10px;
    border: 1px solid #DBBD80;
  }
  ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
    background: #DBBD80;
    color: #FFFFFF !important;
  }
</style>
